import React from 'react';
const Product: React.FC = () => {
  return (
    <div>
      <h1>Our Products</h1>
      <p>Explore the products we offer.</p>
    </div>
  );
}

export default Product;
